import React from "react";

import { SubscribersFilter } from "./SubscribersFilter";
import { SubscribersSummary } from "./SubscribersSummary";
import { SubscribersTable } from "./SubscribersTable";
import SubscribersNotification from "../../../components/atoms/SubscribersNotification";

import { SubscriptionDetails } from "./Drawer/SubscriptionDetails";

import { Container } from "./styles";
import { Alerts } from "./Alerts";
import { useLocation } from 'react-router-dom'
import { useMerchant } from "../../../store/global/useMerchant";

export function Subscribers() {
  const { search } = useLocation()
  const merchant = useMerchant(st => st.data.merchant)

  const isAdmin = new URLSearchParams(search).get('admin') === 'true'
  const showStores = ['63c589dfe103ba621df10ed8']
  const showActions = showStores.includes(merchant.id) || isAdmin

  return (
    <>
      <Container>
        {/* <SubscribersNotification /> */}
        <SubscribersFilter />
        <SubscribersSummary />
        {showActions && <div id="cancel-link" className="px-4" />}
        <SubscribersTable />
      </Container>
      <Alerts />
      <SubscriptionDetails />
    </>
  );
}
